export default "__VITE_ASSET__8e70338a__"